import { useState } from 'react';
import Button from '@mui/material/Button';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

export default function RetailerLookupButton({
  form,
  setForm,
  backgroundColor,
  color,
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleRetailerLookup = async e => {
    setLoading(true);
    try {
      const response = await axios.post(
        process.env.REACT_APP_ENDPOINT_RSS_RETAILER_LOOKUP,
        {
          agentNumber: form.retailerId,
          jurisdiction: form.jurisdiction,
        },
      );

      // Update the formData state with the response data
      setForm(prevData => ({
        ...prevData,
        storeName: response.data.name, // Populate storeName field
        address: response.data.address1, // Populate address field
        phone: response.data.phone, // Populate phone field
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error searching Retailer:', error);
    }
  };

  return (
    <Button
      variant={'contained'}
      loading={loading}
      disabled={loading || !form.retailerId}
      onClick={handleRetailerLookup}
      sx={{
        backgroundColor: backgroundColor,
        color: color,
        fontSize: { xs: '0.7rem', md: '0.875rem' },
        px: { xs: 1, md: 2 },
        py: { xs: 0.5, md: 0.75 },
        minWidth: 'unset',
      }}
    >
      {t('buttons.retailer_id_lookup')}
    </Button>
  );
}
